import { render } from "./top-header.vue?vue&type=template&id=639a53a7&ts=true"
import script from "./top-header.ts?vue&type=script&lang=ts&external"
export * from "./top-header.ts?vue&type=script&lang=ts&external"

import "./top-header.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__